import axios from 'axios';

const deletePurchaseOrderApi = async (token, id) => {
  const formDate = new FormData();
  formDate.append('id', id);
  try {
    const res = await axios.post(
      '/BuyOrder/delete',
      formDate,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'applications/json',
          Authorization: 'Bearer ' + token,
          lang: 'ar'
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export default deletePurchaseOrderApi;
